import { Drawer } from 'antd';
import { useState } from 'react';
import { AutomateLabels } from './AutomateLabels';
import { ReviewsCategories } from './ReviewsCategories';
import { TestLabelWithAIDrawer } from './TestLabelWithAIDrawer';
import { DrawerPanelTitle, drawerPanelStyles } from '../../../../common/Drawers/DrawerPanelTitle';
import { SettingOutlined } from '@ant-design/icons';

export const LabelIADrawer = (props: { onClose: any }) => {

	const [openDrawer, setOpenDrawer] = useState(false);

	return (
		<Drawer
			placement="right"
			width={'44%'}
			title={
				<DrawerPanelTitle
					title={<><SettingOutlined/> Etiquetado con IA</>}
					isProject={false}
				/>
			}
			onClose={() => props.onClose(false)}
			open={true}
			{...drawerPanelStyles}
		>
			<div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
				<section style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
					<div style={{
						fontSize: 11,
						fontWeight: 600,
						color: '#475569',
						letterSpacing: '0.03em',
						textTransform: 'uppercase',
						paddingLeft: 2,
					}}>
						Automatización
					</div>
					<AutomateLabels />
				</section>

				<section style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
					<div style={{
						fontSize: 11,
						fontWeight: 600,
						color: '#475569',
						letterSpacing: '0.03em',
						textTransform: 'uppercase',
						paddingLeft: 2,
					}}>
						Lista de categorías
					</div>
					<ReviewsCategories onTestClick={() => setOpenDrawer(true)} />
				</section>
			</div>

			{openDrawer && <TestLabelWithAIDrawer openDrawer={openDrawer} setOpenDrawer={setOpenDrawer} />}
		</Drawer>
	)
}
